import SingleImage from 'global/components/sem/SingleImage';
import React, { useCallback } from 'react'

export const useImageElement = () => {

  const getImageElement = useCallback(({ isVisible, fullImageProps, _trueImageUrl, transition_image, imageOptions }) => {
    return getCardElement({ isVisible, fullImageProps, _trueImageUrl, transition_image, imageOptions })
  }, []);

  return { getImageElement }
}

const getCardElement = ({ isVisible, fullImageProps, _trueImageUrl, transition_image, imageOptions }) => {
  if (fullImageProps) {
    const cip = { _trueImageUrl, fullImageProps, transition_image, ...imageOptions }
    return { type: 'image', element: <SingleImage {...cip} /> }
  }
}